import { ClassName, Size, Tray } from '@busybusy/webapp-react-ui';
import { ChevronLeftIcon, ChevronRightIcon } from 'assets/icons';
import classNames from 'classnames';
import IconButton from 'components/foundation/buttons/IconButton/IconButton';
import ConditionalContainer from 'components/foundation/ConditionalContainer/ConditionalContainer';

export interface IBasicArrowedDateRangeProps {
  label: string;
  forward?: () => void;
  back?: () => void;
  forwardEnabled: boolean;
  backEnabled: boolean;
  datePosition?: BasicArrowDateRangePosition;
  className?: ClassName;
}

const ArrowedDateRangeDateLeft = ['date', 'back', 'forward'] as const;
const ArrowedDateRangeDateMiddle = ['back', 'date', 'forward'] as const;
const ArrowedDateRangeDateRight = ['back', 'forward', 'date'] as const;

export type BasicArrowDateRangePosition = 'start' | 'middle' | 'end';

const orderLookupMap = {
  start: ArrowedDateRangeDateLeft,
  middle: ArrowedDateRangeDateMiddle,
  end: ArrowedDateRangeDateRight,
};

export default function BasicArrowedDateRange({
  label,
  datePosition = 'end',
  forward,
  back,
  forwardEnabled,
  backEnabled,
  className,
}: IBasicArrowedDateRangeProps) {
  const order = orderLookupMap[datePosition];

  return (
    <Tray spacing={1} className={classNames('basic-arrowed-date-range', className)}>
      {order.map((o) => {
        switch (o) {
          case 'back':
            return (
              <ConditionalContainer condition={!!back} key={o}>
                <IconButton svg={ChevronLeftIcon} onClick={back} buttonSize={Size.SMALL} disabled={!backEnabled} />
              </ConditionalContainer>
            );
          case 'forward':
            return (
              <ConditionalContainer condition={!!forward} key={o}>
                <IconButton
                  svg={ChevronRightIcon}
                  onClick={forward}
                  buttonSize={Size.SMALL}
                  disabled={!forwardEnabled}
                />
              </ConditionalContainer>
            );
          case 'date':
            return (
              <h2 className="fw-regular px-2" key={o}>
                {label}
              </h2>
            );
          default:
            return null;
        }
      })}
    </Tray>
  );
}
